import { Component, HostListener } from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-copyright',
  imports: [],
  templateUrl: './copyright.component.html',
  styleUrl: './copyright.component.scss'
})
export class CopyrightComponent {
  constructor(
    private navigationService: HelpNavigationService) { }
  selectedSection = 'copyright';

  ngOnInit(): void {

    this.navigationService.selectedSection.next('copyright');

    this.navigationService.selectedSection.subscribe(section => {
      this.selectedSection = section;
    });

  }

  changeSection(section: string): void {

    this.navigationService.selectedSection.next(section);

    setTimeout(() => {

      const element =
        document.getElementById(section);

      element?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 50);

  }
}
